import TemplatePDFCreator from "../../components/TemplatePDFCreator";

const CustomPDF = () => {
  return (
    <div>
      <TemplatePDFCreator />
    </div>
  );
};

export default CustomPDF;
